import $ from "jquery";

// import script accordingly
import "./themes/header/_header";
import "./themes/slider/_slider";
// import "./themes/header/_footer";
